export default __webpack_public_path__ + "static/media/s0981_historia_clinica_evaluac_preq_curvas.600a0259.pdf";